<template>
  <router-link to="/client-masters" class="client-service-aside__item">
    <h3 class="client-service-aside__subtitle">{{pop_name}}</h3>
    <span v-if="!hasLevels" class="client-service-aside__price">{{pop_price}}</span>
  </router-link>
</template>
<script>
export default {
  name: "PopularService",
  props: {
    pop_name: String,
    pop_price: Number,
    pop_id: Number,
    pop_index: Number,
    pop_dur: String,
    pop: Object
  },
  computed: {
    hasLevels() {
      return this.pop.levels.length > 0;
    }
  }
};
</script>
